import { render } from "./Depilation.vue?vue&type=template&id=494139fe&scoped=true"
import script from "./Depilation.vue?vue&type=script&lang=js"
export * from "./Depilation.vue?vue&type=script&lang=js"

import "./Depilation.vue?vue&type=style&index=0&id=494139fe&lang=css"
import "./Depilation.vue?vue&type=style&index=1&id=494139fe&scoped=true&lang=css"
import "./Depilation.vue?vue&type=style&index=2&id=494139fe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494139fe"]])

export default __exports__